import type { GameView } from '@big2/shared';
import { Icon } from '../../Icon.js';

/**
 * Daaluu-only status for the local player, shown as chips in the shared self-counter bar
 * (your own seat is not drawn on the felt, as in the other games).
 */
export function DaaluuSelfStatus({ game, mn }: { game: GameView; mn: boolean }) {
  const d = game.daaluu!;
  const seat = game.mySeat;
  const master = d.ledger.masters[seat];
  const freedomTarget = d.freedomHousesBySeat?.[seat] ?? d.freedomHouses ?? 2;
  const debts = d.ledger.debt[seat].flatMap((amount, creditor) => amount > 0
    ? [{ amount, seat: creditor, name: game.players.find(p => p.seat === creditor)?.name ?? `Player ${creditor + 1}` }] : []);
  const debtTotal = debts.reduce((total, debt) => total + debt.amount, 0);
  const callerLabel = mn ? 'Энэ тойргийн дуудагч' : "This round's caller";
  return <>
    {seat === d.callerSeat && <span className="self-card-ratio daaluu-self-caller" role="img" aria-label={callerLabel} title={callerLabel}>
      <Icon name="crown" size={13} />
    </span>}
    {master !== null && <span className="self-card-ratio" title={`${mn ? 'Ноён' : 'Master'}: ${game.players.find(p => p.seat === master)?.name}`}>
      {mn ? 'Ноён' : 'Master'}: <strong>{game.players.find(p => p.seat === master)?.name}</strong>
    </span>}
    {master !== null && (d.earnedHouses?.[seat] ?? 0) >= freedomTarget && <span className="self-card-ratio">{mn ? 'Тойргийн эцэст чөлөөлөгдөнө' : 'Free at settlement'}</span>}
    {debts.length > 0 && <span className="daaluu-debt self-card-ratio">
      <button type="button" className="daaluu-debt-trigger" aria-describedby="daaluu-debt-self" aria-label={`${mn ? 'Өр' : 'Debt'}: ${debtTotal}`}>
        {mn ? 'Өр' : 'Debt'}: <strong>{debtTotal}</strong>
      </button>
      <span className="daaluu-debt-tooltip" id="daaluu-debt-self" role="tooltip">
        <strong>{mn ? 'Хэнд төлөх вэ' : 'Owed to'}</strong>
        {debts.map(({ seat: creditor, name, amount }) => <span className="daaluu-debt-row" key={creditor}>
          <span>{name}</span><span>{amount} {mn ? 'цай' : 'tea'}</span>
        </span>)}
      </span>
    </span>}
  </>;
}
